import { withTranslation } from "react-i18next";
import React, { Component } from 'react'
import "../../scss/buttons.scss";
import i18n from "../../i18n";
import globalConfig from '../../config/global/config.json';
import SocialIcons from "../SocialIcons/SocialIcons";
import './Footer.scss';

// const arrowIcon = require('../../../public/images/Icons-Arrow-Right');

export class Footer extends Component {

    gcpLogoPath = () => i18n.exists("configuration:SET_GCP_LOGO_PATH") ? i18n.t("configuration:SET_GCP_LOGO_PATH") : globalConfig.SET_GCP_LOGO_PATH;

    render() {
        const { t } = this.props;
        let footerLinks = t('footer#footerLinks', { returnObjects: true });
        var footerLinksCollection = footerLinks.map((links) => <a key={links.label} target="_blank" href={links.url} rel="noreferrer">{links.label}</a>
        );
        const year = new Date().getFullYear();
        const copyright = t('footer#footerText#copyright', {year: year});
        const zincCode = t('footer#zincCode',{returnObjects: true});
        const zincCodeCollections = zincCode.map(code => <p className="pb-4 px-0 container" key={code}>{code}</p>);
        return  <div>
                    <div className="container-fluid px-3">
                        <div className="container footer-logo-container px-0">
                            <div className='footer-logo'>
                                <a href={window.location.href} title={t("portalLogoAlt")}>
                                    <img className="gcp-logo mt-4" src={this.gcpLogoPath()} alt={t("portalLogoAlt")}/>
                                </a>
                            </div>
                            <SocialIcons/>
                        </div>
                        <footer className="container footer-container p-0 mt-3">
                            {t("footer#adverseEvent") ? 
                            <a className="button button-green mb-3" title={t("footer#adverseEvent#title")} href={t("footer#adverseEvent#url")} target='_blank' rel="noreferrer">{t("footer#adverseEvent#label")}</a> 
                            : null}
                            <p className="mt-1 u-font-weight-bold">{t("footer#footerText#intendedSite")}</p>
                        </footer>
                    </div>
                    <div className="container px-3 footer-box">
                        <div className="links">
                            {footerLinksCollection}           
                        </div>               
                        <p className='copyright-text'>{copyright.split('/n').map(cpyright => <span key={cpyright} className="d-inline-block">{cpyright}</span>)}</p>
                    </div>
                    <div className="mt-3 mb-4 px-3 container-fluid">{zincCodeCollections}</div>
                </div >

    }
}

export default withTranslation()(Footer);